module.exports = __webpack_public_path__ + "img/avatar3.7bbb33f1.png";